module.exports = __webpack_public_path__ + "1fb38e62bd22235a2e83e9a39f6f4d45.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/make-moves-together/cha-runners.png
// module id = 1753
// module chunks = 1